export default __webpack_public_path__ + "static/media/memories.5f7ea8b4.png";